'use strict';

/**
 * Business Solutions split tabs (commerce_assets.split.tabs) — jQuery.
 * Syncs aria attributes, shows one panel, marks the active tab.
 * Avoids :has() / optional chaining so Safari on older iOS does not throw
 * before tab keyboard handlers are bound.
 */
$(function () {
	function findBgInChildren(el) {
		if (!el) {
			return null;
		}

		var bg = window.getComputedStyle(el).backgroundColor;
		if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') {
			return bg;
		}

		var i;
		for (i = 0; i < el.children.length; i++) {
			var found = findBgInChildren(el.children[i]);
			if (found) {
				return found;
			}
		}

		return null;
	}

	function applyNextSiblingMediaBg() {
		var roots = document.querySelectorAll('.experience-commerce_assets-split-tabs');
		var i;
		for (i = 0; i < roots.length; i++) {
			var root = roots[i];
			var media = root.querySelector('.lvz-bst__media');
			if (!media) {
				continue;
			}
			var next = root.nextElementSibling;
			var bg = findBgInChildren(next);
			if (bg) {
				media.style.setProperty('--lvz-next-sibiling-bg', bg);
			}
		}
	}

	try {
		applyNextSiblingMediaBg();
	} catch (e) {
		// Media blend is optional; tab binding must still run.
	}

	function setActive($root, index) {
		var $tabs = $root.find('[data-lvz-bst-tab="true"]');
		var $panels = $root.find('[role="tabpanel"]');
		$tabs.each(function (i) {
			var selected = i === index;
			var $btn = $(this);
			$btn.attr('aria-selected', selected ? 'true' : 'false');
			$btn.attr('tabindex', '0');
			$btn.toggleClass('lvz-bst__tab--active', selected);
		});
		$panels.each(function (i) {
			var on = i === index;
			$(this).attr('aria-hidden', on ? 'false' : 'true');
		});
	}

	$('[data-lvz-bst="true"]').each(function () {
		var $root = $(this);
		if ($root.attr('data-lvz-bst-edit') === 'true') {
			return;
		}
		var $tablist = $root.find('[role="tablist"]');
		if (!$tablist.length) {
			return;
		}
		var $tabs = $root.find('[data-lvz-bst-tab="true"]');
		if (!$tabs.length) {
			return;
		}

		$tabs.attr('tabindex', '0');

		$tablist.on('click', '[data-lvz-bst-tab="true"]', function (e) {
			e.preventDefault();
			var idx = $tabs.index(this);
			if (idx >= 0) {
				setActive($root, idx);
			}
		});

		$tablist.on('keydown', '[data-lvz-bst-tab="true"]', function (e) {
			var key = e.key;
			var cur = $tabs.index(this);
			if (cur < 0) {
				return;
			}

			if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
				e.preventDefault();
				setActive($root, cur);
				return;
			}

			var navKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
			if (navKeys.indexOf(key) < 0) {
				return;
			}
			e.preventDefault();
			var len = $tabs.length;
			var next = cur;
			if (key === 'ArrowRight') {
				next = (cur + 1) % len;
			} else if (key === 'ArrowLeft') {
				next = (cur - 1 + len) % len;
			} else if (key === 'Home') {
				next = 0;
			} else if (key === 'End') {
				next = len - 1;
			}
			setActive($root, next);
			$tabs.eq(next).focus();
		});
	});

	$(window).on('pageshow', function () {
		var active = document.activeElement;
		if (active && active.blur && $(active).closest('[data-lvz-bst="true"]').length) {
			active.blur();
		}
	});
});
